import { render } from "./search.vue?vue&type=template&id=5bf22ca2&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"

import "./search.vue?vue&type=style&index=0&id=5bf22ca2&scoped=true&lang=css"

import exportComponent from "D:\\project\\97job-wechat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf22ca2"]])

export default __exports__